module.exports = __webpack_public_path__ + "Topic.fd837703.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/Topic.png
// module id = 899
// module chunks = 0